let turnServers = [];

export const getTurnServers = () => {
    return turnServers;
}

export const setTurnServers = (servers) => {
    turnServers = servers;
}